'use client'

import { motion } from 'framer-motion'
import { useEffect, useRef } from 'react'

export const AnimatedComplexLine = ({
  component: Component,
  className,
  delay = 0,
}: {
  component: React.ComponentType<{ className?: string }>
  className?: string
  delay?: number
}) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current) return

    const container = containerRef.current
    const lineElement = container.querySelector('svg')
    if (!lineElement) return

    const paths = lineElement.querySelectorAll('path')
    if (paths.length === 0) return

    paths.forEach((path, index) => {
      const length = path.getTotalLength()

      path.style.strokeDasharray = `${length}`
      path.style.strokeDashoffset = `${length}`

      path.animate([{ strokeDashoffset: length }, { strokeDashoffset: 0 }], {
        duration: 1000,
        delay: delay * 1000 + index * 250,
        fill: 'forwards',
        easing: 'ease-in-out',
      })
    })
  }, [delay])

  return (
    <motion.div
      ref={containerRef}
      className={`${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, delay }}
    >
      <Component className="h-full w-full [&>path]:fill-transparent [&>path]:stroke-reeve-primary [&>path]:stroke-[2px]" />
    </motion.div>
  )
}
